import React from 'react';
import PropTypes from 'prop-types';
import { HELP_CHAT_INTERCOM_ID } from '@umai/common';
import styles from './AccessMessage.module.scss';

const AccessMessage = ({ title, description, subTitle, header, footer }) => (
  <section className={styles.accessMessage}>
    <h2 className={styles.header}>{header}</h2>
    <h3 className={styles.title}>{title}</h3>
    <p className={styles.description}>{description}</p>
    <p className={styles.subTitle} id={HELP_CHAT_INTERCOM_ID}>
      {subTitle}
    </p>
    <footer className={styles.footer}>{footer}</footer>
  </section>
);

AccessMessage.propTypes = {
  header: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
  subTitle: PropTypes.node.isRequired,
  footer: PropTypes.node,
};

export default AccessMessage;
